<template>
    <l-layout>
        <slot></slot>
    </l-layout>
</template>
<style type="text/css">

</style>
<script type="text/javascript">
    export default {
        data() {
            return {}
        },
        mounted() {},
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// front-main.vue?7f008246